import React, { useRef } from "react";
import { getDaysInFYMonths, months } from "../../../Utilitie";
import DownloadExcel from "../../../Extra/DownloadExcel";
const tableHead = [
  "Financial Year",
  "Wagons/day",
  "wagons",
  "Weight in MT",
  "Freight Cr",
];

const SAYearWiseMaster = ({ data }) => {
  // console.log(data);
  const tableRef = useRef();
  const years = [...new Set(data?.map((o) => o.F_YEAR))].sort(
    (a, b) => b.replace("_", "") - a.replace("_", "")
  );

  return (
    <div className="fade-in-up">
      <div className="table-responsive ">
        <table
          className="table newUiTable table-striped table-hover"
          ref={tableRef}
          style={{ fontSize: "11.5px", fontWeight: "bold" }}
        >
          <thead>
            <tr>
              {tableHead.map((head, i) => {
                return <th key={i}>{head}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {years.map((year, j) => {
              let yearObj = data.filter((o) => o.F_YEAR === year);
              let tempMonths = [
                ...new Set(yearObj.map((o) => o.A_MONTH.toUpperCase())),
              ];

              let month = tempMonths.sort(
                (a, b) => months.indexOf(a) - months.indexOf(b)
              );
              let days = yearObj
                ? getDaysInFYMonths(year.replace("-", "_"), month)
                : 1;

              return (
                <tr key={j}>
                  <td>{year}</td>
                  <td>
                    {(
                      yearObj.reduce((sum, o) => {
                        return sum + (Number(o.WAGON) || 0);
                      }, 0) / days
                    ).toFixed(0)}
                  </td>
                  <td>
                    {(
                      yearObj.reduce((sum, o) => {
                        return sum + (Number(o.WAGON) || 0);
                      }, 0) / 1000
                    ).toFixed(2)}
                    K
                  </td>{" "}
                  <td>
                    {(
                      yearObj.reduce((sum, o) => {
                        return sum + (Number(o.CH_WEIGHT) || 0);
                      }, 0) / 1000000
                    ).toFixed(2)}
                    MT
                  </td>{" "}
                  <td>
                    {(
                      yearObj.reduce((sum, o) => {
                        return sum + (Number(o.FREIGHT) || 0);
                      }, 0) / 10000000
                    ).toFixed(0)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`7A loading Year wise`} />
    </div>
  );
};
export default SAYearWiseMaster;
